/**
 * Lot of this code is the same as parts of script.js, because of 2 ways to login. Keep this in mind when editing.
 */
$(() => {
    // TODO: figure out some new validation?

    $('#login-email-address-input').keypress(function(event){

        $('#incorrect-credentials-alert').addClass('hidden');
        const keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode === 13){

            if($('#login-password-input').val().length !== 0) {
                $('#login-btn').click();
            }
        }
    });

    $('#login-password-input').keypress(function(event){
        $('#incorrect-credentials-alert').addClass('hidden');
        const keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode === 13){

            $('#login-btn').click();
        }
    });

    $('#login-btn').click((event) => {
        event.preventDefault();

       $('#signin')[0].classList.add('was-validated');

        if($('#signin')[0].checkValidity()) {

            // TODO: add loading state.
            $.ajax({
                type: "POST",
                url: '/users/login',
                data: {email_address: $('#login-email-address-input').val(), password: $('#login-password-input').val()}
            }).done(function() {
                let redirect = $('#signin').data('redirectUrl');

                // To prevent login loops.
                if (redirect === '/users/logout') {
                    redirect = '/';
                }
                window.location.href = redirect;
                // TODO: Maybe show a toast, flash or something on success?
            }).fail(function( jqXHR, textStatus, errorThrown ) {
                // TODO: Show appropriate error.

                if (jqXHR.responseJSON) {

                    switch (jqXHR.responseJSON.reason) {
                        case 'incorrect_credentials':
                            $('#incorrect-credentials-alert').removeClass('hidden');
                            break;
                        case 'user_not_activated': {
                            const newToast = $(`<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">
                                <div class="toast-header bg-warning text-dark">
                                    <i class="ai-triangle-alert fs-lg me-2"></i>
                                    <span class="fw-medium me-auto">Account niet geactiveerd</span>
                                    <button type="button" class="btn-close ms-2" data-bs-dismiss="toast" aria-label="Sluiten"></button>
                                </div>
                                <div class="toast-body text-dark">Uw account is nog niet geactiveerd. Neem contact op met Vredenburg om uw account te activeren.</div>
                            </div>`);
                            newToast[0].addEventListener('hidden.bs.toast', () => $(newToast).remove());
                            $('#toast-container').append(newToast);
                            bootstrap.Toast.getOrCreateInstance(newToast).show();
                            break;
                        }
                    }
                }
            }).always(function( data, textStatus, errorThrown ) {
                // TODO: Remove loading state.
            });
        } else {

            if($('#login-email-address-input').val().length === 6 && !isNaN($('#login-email-address-input').val())) {

                const newToast = $(`<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">
                                <div class="toast-header bg-danger text-white">
                                    <i class="ai-triangle-alert fs-lg me-2"></i>
                                    <span class="fw-medium me-auto">Inloggen met e-mailadres!</span>
                                    <button type="button" class="btn-close btn-close-white ms-2" data-bs-dismiss="toast"aria-label="Sluiten"></button>
                                </div>
                                <div class="toast-body text-danger">Gebruik uw e-mailadres om in te loggen, inloggen met klantnummer is niet langer mogelijk.</div>
                            </div>`
                );

                newToast[0].addEventListener('hidden.bs.toast', () => {

                    $(newToast).remove();
                });

                $('#toast-container').append(newToast);

                bootstrap.Toast.getOrCreateInstance(newToast).show();
            }
        }
    });

});
